import { useState } from 'react';
import { Button, Collapse, Space, Tag, Typography } from 'antd';

import IconCustom from 'src/components/Icon/Custom';

import classes from './index.module.less';

const FAQContainer = (props: any) => {
	const [faqActive, setFaqActive] = useState<any>([]);
	const onChange = (key: string | string[]) => {
		setFaqActive([...key]);
	};
	return (
		<>
			<div className={classes['page-body-wrap']}>
				<div className="container">
					<div style={{ textAlign: 'center', paddingTop: '30px' }}>
						<Tag
							color="#FCF8F8"
							style={{ border: '1px solid #F48A8A', borderRadius: '10px', textAlign: 'center' }}
						>
							<Typography style={{ color: '#F48A8A', fontWeight: 'bold' }}>FAQ</Typography>
						</Tag>
					</div>
					<div className={classes['faq-group']} style={{ marginTop: '-20px' }}>
						<h2 className={classes.title}>Sering Ditanyakan</h2>
						<Typography className={classes.paragraph}>
							Hallo Ma! Ada pertanyaan Mama disini? ini daftar pertanyaan yang sering ditanyakan dan
							kami udah nyiapin jawaban yang tepat dan informatif buat Mama
						</Typography>
						<div className={classes['fav-question-group']}>
							<Space direction="vertical">
								{/* <Collapse
									bordered={false}
									expandIcon={({ isActive }) =>
										isActive ? (
											<IconCustom iconName="faq-active" />
										) : (
											<IconCustom iconName="faq-inactive" />
										)
									}
									onChange={onChange}
									expandIconPosition="end"
									style={{ backgroundColor: '#fff' }}
								>
									{props.faq.map((content: any, index: any) => (
										<Panel
											header={
												// <p
												// 	className={classes.header}
												// 	style={{
												// 		color: `${
												// 			index == faqActive[0] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[1] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[2] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[3] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[4] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[5] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[6] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[7] - 1
												// 				? '#F36D6D'
												// 				: index == faqActive[8] - 1
												// 				? '#F36D6D'
												// 				: '#343a40'
												// 		}`,
												// 	}}
												// >
												<p
													className={classes.header}
													style={{
														color: faqActive?.includes(String(content.sequence))
															? '#F36D6D'
															: '#343a40',
													}}
												>
													{content.title}
												</p>
											}
											key={content.sequence}
											style={{
												backgroundColor: '#FCF8F8',
												borderRadius: '20px',
												border: 'none',
												marginBottom: '10px',
											}}
										>
											<div
												dangerouslySetInnerHTML={{
													__html: content.detail,
												}}
											/>
										</Panel>
									))}
								</Collapse> */}
								<Collapse
									bordered={false}
									expandIcon={({ isActive }) =>
										isActive ? (
											<IconCustom iconName="faq-active" />
										) : (
											<IconCustom iconName="faq-inactive" />
										)
									}
									onChange={onChange}
									expandIconPosition="end"
									style={{ backgroundColor: '#fff' }}
									items={props.faq.map((content: any) => ({
										key: content.sequence,
										label: (
											<p
												className={classes.header}
												style={{
													color: faqActive?.includes(String(content.sequence))
														? '#F36D6D'
														: '#343a40',
												}}
											>
												{content.title}
											</p>
										),
										children: (
											<div
												dangerouslySetInnerHTML={{
													__html: content.detail,
												}}
											/>
										),
										style: {
											backgroundColor: '#FCF8F8',
											borderRadius: '20px',
											border: 'none',
											marginBottom: '10px',
										},
									}))}
								/>
							</Space>

							<div className={classes.faqfooter}>
								<Typography
									className={classes.paragraph}
									style={{ color: '#000', marginBottom: '20px' }}
								>
									Ada pertanyaan, keluhan atau masukan seputar aplikasi Hallobumil?
								</Typography>
								<Button
									className={classes.btn}
									href="/hubungi-kami"
									size="large"
									id="home-hubungi-kami-faq"
								>
									Hubungi Kami Yuk, Ma
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default FAQContainer;
